var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInitAutopayLaunch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1154 23.32L1 49L26.6672 39.904M5.7976 3.4H5.82159H5.7976ZM48.976 15.4H49H48.976ZM32.1844 1H32.2084H32.1844ZM48.976 44.2H49H48.976ZM48.976 1L43.6027 2.8C42.0732 3.30973 40.7681 4.33513 39.9105 5.70094C39.053 7.06674 38.6961 8.68814 38.9011 10.288C39.1409 12.352 37.5337 14.2 35.4228 14.2H34.5112C32.4483 14.2 30.6732 15.64 30.2894 17.656L29.7856 20.2M48.976 27.4L47.009 26.608C44.946 25.792 42.6432 27.088 42.2594 29.272C41.9955 30.952 40.5322 32.2 38.8291 32.2H36.982M22.5892 1L23.3808 2.968C24.1964 5.032 22.9011 7.336 20.7181 7.72C19.039 7.96 17.7916 9.448 17.7916 11.152V13",
    fill: "url(#paint0_linear_2631_36065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1154 23.32L1 49L26.6672 39.904M5.7976 3.4H5.82159M48.976 15.4H49M32.1844 1H32.2084M48.976 44.2H49M48.976 1L43.6027 2.8C42.0732 3.30973 40.7681 4.33513 39.9105 5.70094C39.053 7.06674 38.6961 8.68814 38.9011 10.288C39.1409 12.352 37.5337 14.2 35.4228 14.2H34.5112C32.4483 14.2 30.6732 15.64 30.2894 17.656L29.7856 20.2M48.976 27.4L47.009 26.608C44.946 25.792 42.6432 27.088 42.2594 29.272C41.9955 30.952 40.5322 32.2 38.8291 32.2H36.982M22.5892 1L23.3808 2.968C24.1964 5.032 22.9011 7.336 20.7181 7.72C19.039 7.96 17.7916 9.448 17.7916 11.152V13",
    stroke: "url(#paint1_linear_2631_36065)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.589 27.4C27.2187 32.032 29.3776 37.408 27.3866 39.4C25.3956 41.392 20.0223 39.232 15.3926 34.6C10.7629 29.968 8.60398 24.592 10.595 22.6C12.586 20.608 17.9593 22.768 22.589 27.4Z",
    stroke: "url(#paint2_linear_2631_36065)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2631_36065",
    x1: 31.6432,
    y1: 1,
    x2: 9.80698,
    y2: 40.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2631_36065",
    x1: 31.6432,
    y1: 1,
    x2: 9.80698,
    y2: 40.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2631_36065",
    x1: 21.52,
    y1: 21.8582,
    x2: 13.2001,
    y2: 36.9494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE570"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitAutopayLaunch);
export default __webpack_public_path__ + "static/media/initAutopayLaunch.d6bacfc9761f1414967aff3d7fa08226.svg";
export { ForwardRef as ReactComponent };